import React from 'react';
import InputGroup from '../../../../../components/form/InputGroup';
import { useModalOtpData, useSetFormValue } from '../../../../../stores/otpModal.store';
import useOtpModal from '../../../../../hooks/useOtpModalFunctions';
import useTags from '../../../../../hooks/useTags';
import otpModalLang from '../../../../../data/lang/homePage/otpModal.lang';
import AlertUser from '../../../../../components/Alerts/AlertUser';
import { useProjectConfigContext } from '../../../../../contexts/ProjectConfigContext';
import formErrorsLang from '../../../../../data/lang/form-errors.lang';


const PreOtpForm = () => {

  const { projectConfigState } = useProjectConfigContext();
  const { otpStep, portalAction, otpForm } = useModalOtpData();
  const { handleBlurOtpInput } = useOtpModal();
  const { values, errors, touched } = otpForm;

  const setFormValue = useSetFormValue();

  const disabledInputPermitDetails = otpStep === 'otp-input';

  const generateTag = useTags();

  const vehicleNumInputLabel = generateTag(otpModalLang, 'form.vehicle-num-input-label');
  const personIdInputLabel = generateTag(otpModalLang, 'form.person-id-input-label');
  const cancelingPermitWarningText = generateTag(otpModalLang, 'form.warning.canceling-permit');
  const renewdPermitWarningText = generateTag(otpModalLang, 'form.warning.renewed-permit');

  const hasCancelAlert = portalAction === 'CANCEL_PERMIT';
  const hasRenewAlert = portalAction === 'RENEWED_PERMIT_OPTION';

  const showAlerts = hasCancelAlert || hasRenewAlert;

  const sendOtpCodeVia = projectConfigState.homePageConfig.sendingCitizenOtpCodeVia;

  const actionOn = (portalAction === 'ADD_FILE_TO_REQUEST' || portalAction === 'CHECK_REQUEST_STATUS') ? 'request' : 'permit';

  const actionOnTag = generateTag(otpModalLang, `description.${actionOn}`);
  const modalLine1Tag = generateTag(otpModalLang, `description.line-1`);
  const modalLine2Tag = generateTag(otpModalLang, `description.line-2`);
  const descOtpirstPartTag = generateTag(otpModalLang, `description.otp-msg.first-part`);
  const descOtpViaTag = generateTag(otpModalLang, `description.otp-msg.via.${sendOtpCodeVia}`);
  const descOtpLastPartTag = generateTag(otpModalLang, `description.otp-msg.last-part.${sendOtpCodeVia}`);

  const vehicleNumError = (errors.vehicleNum && touched.vehicleNum) && errors.vehicleNum;
  const personIdError = (errors.personId && touched.personId) && errors.personId;

  const vehicleNumErrorMsg = generateTag(formErrorsLang, vehicleNumError);
  const personIdErrorMsg = generateTag(formErrorsLang, personIdError);

  if (otpStep !== 'pre-otp-input') {
    return null;
  }

  return (
    <>

      <AlertUser state={{
        alertColor: 'secondary',
        alertStatus: 'hasAlert',
        message: (
          <>
            <div className="">
              <p>
                {modalLine1Tag} <span className='fst-italic fw-semibold text-primary'>{actionOnTag}</span>.
                <br />
                {modalLine2Tag} <span className='fst-italic'>{actionOnTag}</span>.
              </p>
              <p>
                {descOtpirstPartTag} <span className='fst-italic text-primary'>{descOtpViaTag}</span> {descOtpLastPartTag}.
              </p>
            </div>
          </>
        )
      }}

      />

      {/* -- Locate Permit Details -- */}
      <div className='row'>

        <div className='col-12 col-sm-6'>
          <InputGroup
            value={values.vehicleNum}
            name='vehicleNum'
            type='number'
            label={vehicleNumInputLabel}
            handleChange={e => setFormValue('vehicleNum', e.target.value)}
            handleBlur={handleBlurOtpInput}
            disabled={disabledInputPermitDetails}
            errorMsg={vehicleNumErrorMsg}
          />
        </div>

        <div className='col-12 col-sm-6'>
          <InputGroup
            value={values.personId}
            name='personId'
            type='number'
            label={personIdInputLabel}
            handleChange={e => setFormValue('personId', e.target.value)}
            handleBlur={handleBlurOtpInput}
            disabled={disabledInputPermitDetails}
            errorMsg={personIdErrorMsg}
          />
        </div>

      </div>

      {/*-- Alerts ---*/}
      {showAlerts && (
        <div className='row mt-3'>

          <div className='col-12'>
            <AlertUser
              state={{
                alertColor: 'warning',
                alertStatus: hasCancelAlert ? 'hasAlert' : 'noAlert',
                message: cancelingPermitWarningText
              }} />
          </div>

          <div className='col-12'>
            <AlertUser
              state={{
                alertColor: 'info',
                alertStatus: hasRenewAlert ? 'hasAlert' : 'noAlert',
                message: renewdPermitWarningText
              }} />
          </div>

        </div>
      )}

    </>
  );
}

export default PreOtpForm;